import React, { useState } from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';

const ALLOCATION_DATA = [
  { name: 'Technology', value: 35, color: '#0B1F3B' },
  { name: 'Healthcare', value: 20, color: '#D4A520' },
  { name: 'Finance', value: 18, color: '#0D9488' },
  { name: 'Consumer', value: 12, color: '#2D4A87' },
  { name: 'Energy', value: 8, color: '#D4A520' },
  { name: 'Other', value: 7, color: '#94A3B8' },
];

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload?.length) {
    return (
      <div className="rounded-lg shadow-lg px-3 py-2 border" style={{ background: 'var(--color-primary)', borderColor: 'rgba(201,160,32,0.3)' }}>
        <p className="font-caption text-white/70 text-xs">{payload?.[0]?.name}</p>
        <p className="font-data font-bold text-sm" style={{ color: 'var(--color-accent)' }}>{payload?.[0]?.value}%</p>
      </div>
    );
  }
  return null;
};

export default function AllocationChart() {
  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <div className="rounded-xl border p-4 md:p-6 h-full" style={{ borderColor: 'var(--color-border)', background: 'var(--color-card)' }}>
      <h2 className="font-heading font-semibold text-lg md:text-xl mb-4" style={{ color: 'var(--color-foreground)' }}>Asset Allocation</h2>
      <div className="w-full h-48 md:h-56">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie data={ALLOCATION_DATA} cx="50%" cy="50%" innerRadius="55%" outerRadius="80%"
              paddingAngle={3} dataKey="value"
              onMouseEnter={(_, index) => setActiveIndex(index)}
              onMouseLeave={() => setActiveIndex(null)}>
              {ALLOCATION_DATA?.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry?.color}
                  opacity={activeIndex === null || activeIndex === index ? 1 : 0.6}
                  stroke={activeIndex === index ? 'white' : 'transparent'}
                  strokeWidth={activeIndex === index ? 2 : 0} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className="grid grid-cols-2 gap-2 mt-2">
        {ALLOCATION_DATA?.map((item, i) => (
          <div key={item?.name} className="flex items-center gap-2">
            <div className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ background: item?.color }} />
            <span className="font-caption text-xs truncate" style={{ color: 'var(--color-muted-foreground)' }}>{item?.name}</span>
            <span className="font-data text-xs font-semibold ml-auto" style={{ color: 'var(--color-foreground)' }}>{item?.value}%</span>
          </div>
        ))}
      </div>
    </div>
  );
}